import styled from "styled-components";
import { Card, Header } from "semantic-ui-react";
import { theme } from "../../../styling/theme";

export const PromptCardStyle = styled(Card)({
  background: `${theme.lightBackgroundColor} !important`,
  borderRadius: "6.3px !important",
  border: `1px solid ${theme.backgroundColor} !important`,
  minWidth: "836px !important", // ojo dani
  margin: "5px 0 !important",
});

export const PromptHeader = styled(PromptCardStyle.Header)({
  overflow: "hidden",
  color: theme.titleColor,
  fontWeight: "bold",
  letterSpacing: "-0.24px",
  lineHeight: "19px",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
  width: "100%",
  paddingTop: theme.size.s,
});

export const AutoPostLabel = styled(Header)({
  marginBottom: "0px !important",
});
